import { service } from '../../../helpers/http'

export const ActionGetWorkLoadTypes = ({ dispatch }, payload) => {
    return service({
        module: 'workLoadType',
        action: 'workLoadTypes',
        payload: payload
    })
}

export const ActionCreateWorkLoadType = ({ dispatch }, payload) => {
    return service({
        module: 'workLoadType',
        action: 'workLoadTypeCreate',
        payload: payload
    })
}

export const ActionUpdateWorkLoadType = ({ dispatch }, payload) => {
    return service({
        module: 'workLoadType',
        action: 'workLoadTypeUpdate',
        payload: payload
    })
}

export const ActionDeleteWorkLoadType = ({ dispatch }, payload) => {
    return service({
        module: 'workLoadType',
        action: 'workLoadTypeDelete',
        payload: payload
    })
}

// Aba "Posição Categoria": posição x categoria de turma de um tipo de carga horária.
export const ActionGetWorkLoadTypePositions = ({ dispatch }, payload) => {
    return service({
        module: 'workLoadType',
        action: 'workLoadTypePositions',
        params: { id: payload.id }
    })
}

export const ActionCreateWorkLoadTypePosition = ({ dispatch }, payload) => {
    return service({
        module: 'workLoadType',
        action: 'workLoadTypePositionCreate',
        params: { id: payload.id },
        payload: { category_group_id: payload.category_group_id, position: payload.position }
    })
}

export const ActionUpdateWorkLoadTypePosition = ({ dispatch }, payload) => {
    return service({
        module: 'workLoadType',
        action: 'workLoadTypePositionUpdate',
        params: { id: payload.id, positionId: payload.positionId },
        payload: { category_group_id: payload.category_group_id, position: payload.position }
    })
}

export const ActionDeleteWorkLoadTypePosition = ({ dispatch }, payload) => {
    return service({
        module: 'workLoadType',
        action: 'workLoadTypePositionDelete',
        params: { id: payload.id, positionId: payload.positionId }
    })
}
